/**
 * Message type.
 */
export const enum MessageType {
  /**
   * Regular message.
   */
  Message = 'Message',
  /**
   * System message.
   */
  SystemMessage = 'SystemMessage',
  /**
   * Admin message.
   */
  AdminMessage = 'AdminMessage',
  /**
   * Note.
   */
  Note = 'Note',
  /**
   * External reference.
   */
  ExternalReference = 'ExternalReference',
}
